module.exports = __webpack_public_path__ + "static/media/Goblin.1c16cc07.jpg";